import { render, staticRenderFns } from "./pagamentoBoleto.vue?vue&type=template&id=11562111&scoped=true&"
import script from "./pagamentoBoleto.vue?vue&type=script&lang=js&"
export * from "./pagamentoBoleto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11562111",
  null
  
)

export default component.exports